export default __webpack_public_path__ + "static/media/q20_02.12cd38f7.png";